module.exports = __webpack_public_path__ + "static/chizoba-ea77c1c37e0ed94c85dc78150662ca69.jpg";